import {useEffect, useState} from "react";
import {CircularProgress} from "@mui/material";
import {path} from "../routes";

const NewsFetchPost = () => {

    const [newsData, setNewsData] = useState([]);
    const [weatherData, setWeatherData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const apiKeyNews = '103cea4011e44292b5c47cd9c7808d1c';
    const apiUrlNews = `https://newsapi.org/v2/top-headlines?sources=cnn&apiKey=${apiKeyNews}`;
    const apiKeyWea = '53aaf5c2175c0194becf66b6a9f26436';
    const city = 'Praha';
    const apiUrlWea = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKeyWea}&units=metric`;

    const fetchNews = async () => {
        let tmp = []
        try {
            const response = await fetch(apiUrlNews);
            if (!response.ok) {
                throw new Error('Error fetching news');
            }
            const data = await response.json();
            for (let i = 0; i < 5; i++) {
                tmp.push(data.articles[i].title);
            }
            sendNews(tmp);
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const sendNews = async (data) => {
        try {
            const response = await fetch(`${path}/postNews`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    news: data,  // Odesíláme pole s novinkami
                }),
            });

            if (response.ok) {
                //alert('Novinky byly úspěšně přidány');
            } else {
                alert('Chyba při přidávání novinek');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Chyba při komunikaci se serverem');
        }
    }


    useEffect(()=>{
        fetchNews()
    })

    return <div>
        {loading && <CircularProgress />}
        {error && <label>Something went wrong</label> }
        {!error && <label>Success</label> }
    </div>
}
export default NewsFetchPost;